module.exports = "<main role=\"main\">\n  <div class=\"container\">\n\n    <h2 class=\"text-title\">Vídeos</h2>\n    <div class=\"row\">\n\n      <div class=\"col-sm-12 card\" *ngFor=\"let item of itens | async\">\n        <iframe width=\"560\" height=\"315\" [src]=\"changeEmbedLink(item.link) | img\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>\n\n      </div>\n\n    </div>\n    <br>\n\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/videos/videos.component.html
// module id = ./src/app/videos/videos.component.html
// module chunks = main